import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {PoslovniUgovorDocument} from "../ugovori/PoslovniUgovorDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {UgovorORaduDocument} from "./UgovorORaduDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, zaposleni, sektor
// opciono: opis, lista priloga, pozicija, vrsta radnog odnosa, period

export const ugovorORaduDocumentFields: IntercateKeysMap<UgovorORaduDocument, EntityField<UgovorORaduDocument>> = {
	...baseDocumentFields,
	employeeId: {
		name: "employeeId", dataType: EntityFieldDataType._reference, label: "Zaposleni",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Employees
		},
		validator: { required: true },
		sortable: true
	},
	positionId: {
		name: "positionId", dataType: EntityFieldDataType._reference, label: "Pozicija",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Positions
		},
		validator: { required: false },
		sortable: true
	},
	period: {
		name: "period", dataType: EntityFieldDataType._string, label: "Period",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.employeeId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<UgovorORaduDocument>> = [
	ugovorORaduDocumentFields.indexingNumber,
	ugovorORaduDocumentFields.indexingDate,
	ugovorORaduDocumentFields.documentNumber,
	ugovorORaduDocumentFields.documentDate,
	ugovorORaduDocumentFields.assignedTo,
	ugovorORaduDocumentFields.sectorId,
	ugovorORaduDocumentFields.positionId,
	ugovorORaduDocumentFields.employeeId,
	ugovorORaduDocumentFields.period,
	ugovorORaduDocumentFields.tags,
	ugovorORaduDocumentFields.description,
	ugovorORaduDocumentFields.parentId,
]

export const ugovorORaduDocumentFieldsDescriptor: EntityFieldsDescriptor<UgovorORaduDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
